//React
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
//Libraries
import cx from "classnames";
//Components
import {
  Card,
  DocsHeader,
  DocsScreen,
  FlexBox,
  Footer,
  TitleBlock,
  Image,
} from "components";
//Constants
import { docsConstants } from "../../../constants";
//Utils
import { ChangeHistory, useIsInViewport } from "utils";
//Styles
import "./styles.scss";
//Assets
import JavaIcon from "assets/icons/java.png";
import AndroidIcon from "assets/icons/android.svg";
import AppleIcon from "assets/icons/apple.svg";
import FlutterIcon from "assets/icons/flutter.png";
import Logo from "assets/logo.svg";
//Routes
import ROUTE_PATH from "Routes/paths";

const DocsHome = () => {
  /* Constants */
  //States
  const [scrolledToElement, setScrolledToElement]: any = useState({
    selectedTab: docsConstants.TITLES.OVERVIEW,
  });

  //Refs
  const SdkListRef: any = useRef();
  const isSdkListInViewport = useIsInViewport(SdkListRef);

  /* useEffects */
  useEffect(() => {
    if (isSdkListInViewport) {
      setScrolledToElement({
        selectedTab: docsConstants.TITLES.SDK_AND_API_REFERENCE,
      });
    }
  }, [isSdkListInViewport]);

  const SdkList = (
    <div ref={SdkListRef} className="sdk-list-container">
      <TitleBlock
        title={docsConstants.TITLES.SDK_AND_API_REFERENCE}
        content={
          <div className="sdk-list-section">
            <p className="fs-14">
              OTPless SDKs and APIs allow you to build Login with WhatsApp
              authentication with minimum backend code.
            </p>
            <FlexBox justifyBetween className="mr-t-40 sdk-list text-center">
              <Card
                className="pd-0 w-20 curs-point clicking-animation animated fadeInLeft delay-03s"
                onClick={() => {
                  ChangeHistory("push", ROUTE_PATH.DOCS.SDK.ANDROID);
                }}
              >
                <div className="pd-20">
                  <Image src={AndroidIcon} />
                  <p className="mr-t-20 fs-16 font-heavy">
                    {docsConstants.TITLES.ANDROID.TITLE}
                  </p>
                </div>
              </Card>
              <Card
                className="pd-0 w-20 curs-point clicking-animation animated fadeInLeft delay-05s"
                onClick={() => {
                  ChangeHistory("push", ROUTE_PATH.DOCS.SDK.IOS);
                }}
              >
                <div className="pd-20">
                  <Image src={AppleIcon} />
                  <p className="mr-t-20 fs-16 font-heavy">
                    {docsConstants.TITLES.IOS.TITLE}
                  </p>
                </div>
              </Card>
              <Card
                className="pd-0 w-20 curs-point clicking-animation animated fadeInLeft delay-01s"
                onClick={() => {
                  ChangeHistory("push", ROUTE_PATH.DOCS.SDK.JAVASCRIPT);
                }}
              >
                <div className="pd-20">
                  <Image src={JavaIcon} />
                  <p className="mr-t-20 fs-16 font-heavy">
                    {docsConstants.TITLES.JAVASCRIPT.TITLE}
                  </p>
                </div>
              </Card>
              <Card
                className="pd-0 w-20 curs-point clicking-animation animated fadeInLeft delay-01s"
                onClick={() => {
                  ChangeHistory("push", ROUTE_PATH.DOCS.SDK.FLUTTER);
                }}
              >
                <div className="pd-20">
                  <Image src={FlutterIcon} />
                  <p className="mr-t-20 fs-16 font-heavy">
                    {docsConstants.TITLES.FLUTTER.TITLE}
                  </p>
                </div>
              </Card>
            </FlexBox>
          </div>
        }
        titleClass="fs-24 font-heavy mr-t-20"
        className="animated fadeInUp"
      />
    </div>
  );

  //Return UI
  return (
    <DocsScreen
      className="docs-home-screen sdk-home"
      screenAnimationClass="no-animation"
    >
      <DocsHeader
        title={
          <Image
            src={Logo}
            onClick={() => {
              ChangeHistory("push", ROUTE_PATH.SAMPLES.LANDING);
            }}
            className="clicking-animation"
          />
        }
      />
      <div className="text-center body">{SdkList}</div>
    </DocsScreen>
  );
};

export default DocsHome;
